import React, { useState, useEffect, useContext, useMemo } from "react";
import { fetchJson } from "../../../lib/Fetching";

const ResultsContext = React.createContext(null);

function useResultsContext({ tests }) {
  const [allUnits, setAllUnits] = useState(null);
  const [qualifiers, setQualifiers] = useState(null);

  useEffect(() => {
    fetchJson("/testing/units.json", {}).then((json) => {
      setAllUnits(json.units);
    });
  }, []);

  useEffect(() => {
    fetchJson("/sample_testing/api/qualifiers.json", {}).then((json) => {
      console.log(json.qualifiers);
      setQualifiers(json.qualifiers);
    });
  }, []);

  return {
    units: allUnits,
    qualifiers: qualifiers,
    tests: tests,
  };
}

function useTests() {
  return useContext(ResultsContext).tests;
}

function useQualifiers() {
  return useContext(ResultsContext).qualifiers;
}

function useUnits(unit_id) {
  return useMemo(
    () => {
      const allUnits = useContext(ResultsContext).units;
      const matchingUnit = allUnits.filter((u) => u.id == unit_id)[0];

      if (matchingUnit.id == 23) {
        // when the unit is 'ABSOLUTE' we want to show all units
        return allUnits;
      }

      const compatibleUnits = allUnits.filter((u) => u.unit_id == matchingUnit.unit_id);
      return compatibleUnits;
    },
    [unit_id]
  );
}

export default ResultsContext;
export { useResultsContext, useUnits, useQualifiers, useTests };
